export const sources={};export const img={src:"__VITE_ASSET__yQ5Mw_tp$C5jgqb_o_VSHg__",w:640,h:640};export default{sources:sources,img:img};